import { render } from "./Table.ce.vue?vue&type=template&id=5f5a4355"
import script from "./Table.ce.vue?vue&type=script&lang=js"
export * from "./Table.ce.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__